import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui';
import { ArrowRightLeft, ChevronDown, Database } from 'lucide-react';
import { useConnection } from '../connection-context';

export function ConnectionSelectorButton() {
  const { clearActiveConnection, connectionId } = useConnection();

  // Derive connection info from connectionId
  // Format: gcp-{projectId}__{databaseId}
  const connectionInfo = connectionId?.startsWith('gcp-')
    ? (() => {
        const parts = connectionId.replace('gcp-', '').split('__');
        if (parts.length === 2) {
          return { projectId: parts[0], databaseId: parts[1] };
        }
        return null;
      })()
    : null;

  // Get display name - all connections are GCP connections
  const displayName = connectionInfo
    ? `${connectionInfo.projectId} / ${connectionInfo.databaseId}`
    : 'No Connection';

  const handleChangeConnection = async () => {
    // Clear the active connection to show setup UI
    try {
      await clearActiveConnection();
    } catch (error) {
      console.error('Error clearing active connection:', error);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          <Database className="h-4 w-4" />
          <span className="hidden sm:inline">{displayName}</span>
          <span className="sm:hidden">Connection</span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          {connectionInfo ? (
            <div>
              <div className="font-medium">GCP Connection</div>
              <div className="text-xs text-muted-foreground">
                {connectionInfo.projectId} / {connectionInfo.databaseId}
              </div>
            </div>
          ) : (
            'No Connection Selected'
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={handleChangeConnection}>
          <ArrowRightLeft className="h-4 w-4 mr-2" />
          Change Connection
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
